import React, { ReactElement } from "react"
import { Box, Button as ChakraButton, ButtonProps } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  children: React.ReactNode;
  leftIcon?: string | ReactElement
  rightIcon?: string
  iconSize?: number
  href?: string
  target?: string
  to?: string
} & Omit<ButtonProps, "leftIcon" | "rightIcon" | "disabled">

const Button = ({
  children,
  colorScheme = "button.primary",
  type = "button",
  variant = "solid",
  size = "md",
  iconSize = 3,
  leftIcon,
  rightIcon,
  ...rest
}: Props) => (
  <ChakraButton
    type={type}
    colorScheme={colorScheme}
    size={size}
    variant={variant}
    bgColor={variant === "outline" ? "white" : ""}
    {...leftIcon ? {
      leftIcon: typeof leftIcon === "string" ? <Icon icon={leftIcon} size={iconSize} /> : leftIcon,
    } : {}}
    {...rest}
  >
    <Box lineHeight="short">{children}</Box>
    {rightIcon && <Icon icon={rightIcon} size={iconSize} ml={2} />}
  </ChakraButton>
)

export default Button
